import Message from "./Message";

const isMobile = () => {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

const getUserLanguage = (convertToI18nFormat = false) => {
  let userLanguage = navigator.language || navigator.userLanguage || document.body.dataset.lang.substr(0, 2);
  let lang = userLanguage.slice(0, 2).toLowerCase();
  if (convertToI18nFormat) {
    switch (lang) {
      case 'fr':
        lang = 'fr_FR';
        break;
      case 'en':
        lang = 'en_US';
        break;
      case 'de':
        lang = 'de_DE';
        break;
      case 'it':
        lang = 'it_IT';
        break;
      case 'es':
        lang = 'es_ES';
        break;
      case 'pt':
        lang = 'pt_PT';
        break;
      case 'nl':
        lang = 'nl_NL';
        break;
      case 'zh':
        lang = 'zh_CN';
        break;
      case 'ko':
        lang = 'ko_KR';
        break;
      case 'ja':
        lang = 'ja_JP';
        break;
      case 'ru':
        lang = 'ru_RU';
        break;
      case 'sv':
        lang = 'sv_SE';
        break;
      case 'fi':
        lang = 'fi_FI';
        break;
      default:
        return false;
    }

    return lang;
  }

  return lang;
};

const isHidden = (el) => {
  const style = window.getComputedStyle(el);
  return (style.display === 'none')
};

const isHiddenAlt = (el) => {
  return (el.offsetParent === null);
}

const formattedDate = (d = new Date) => {
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  const year = String(d.getFullYear());

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return `${day}/${month}/${year}`;
};

const dateToString = date => {
  if(date === null)
    return null;
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
};

const ymdFormattedDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

const ajax = (url, callback, method = 'GET', formData = {}, headers = {}, async = true, parseJSON = true, removeButtonLoading = true) => {
  const request = new XMLHttpRequest();
  request.open(method, url, async);

  request.onload = function () {
    if (this.status >= 200 && this.status < 400) {
      // Success!
      let data = {};
      if(parseJSON){
        data = JSON.parse(this.response);
      }
      else{
        data = this.response;
      }

      callback(data);

      if(removeButtonLoading){
        const originalButtons = document.querySelectorAll('.originalButton');
        originalButtons.forEach((button) => {
          button.classList.remove('hidden');
        });

        const clonedButtons = document.querySelectorAll('.clonedButton');
        clonedButtons.forEach((button) => {
          button.remove();
        });
      }
    } else {
      // We reached our target server, but it returned an error
    }
  };

  // request.onerror = function () {
  //   // There was a connection error of some sort
  //   Message.error("Something didn't work, please contact support");
  // };

  if(method === 'POST') {
    let metaCsrf = document.querySelector('meta[name="csrfToken"]');
    if(metaCsrf){
      headers['X-CSRF-Token'] = metaCsrf.content;
    }
  }

  for (const header in headers) {
    if (headers.hasOwnProperty(header)) {
      request.setRequestHeader(header, headers[header]);
    }
  }

  request.send(formData);
  return request;
};

/**
 * Send an AJAX GET request and return the response body as text.
 *
 * @param {string} url - The endpoint URL
 * @returns {Promise<string>}
 */
const getHtml = async (url) => {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      Accept: 'text/html',
      'X-CSRF-Token': getCsrfToken(),
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  if (!response.ok) throw new Error('Something went wrong');

  return response.text();
};

/**
 * Send an AJAX GET request and return the parsed JSON response.
 *
 * @param {string} url - The endpoint URL
 * @returns {Promise<Object>}
 */
const getJson = async (url) => {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken(),
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  const json = await response.json();
  if (!response.ok || !json.success) {
    const error = new Error(json.message || 'Something went wrong');
    error.data = json;

    throw error;
  }

  return json;
};

/**
 * Send a POST request and return the parsed JSON response.
 *
 * @param {string} url - The endpoint URL
 * @param {Object|FormData} payload - JSON object or form fields
 * @returns {Promise<Object>}
 */
const postJson = async (url, payload = {}) => {
  const isFormData = payload instanceof FormData;

  const response = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      'X-CSRF-Token': getCsrfToken(),
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: isFormData ? payload : JSON.stringify(payload)
  });

  const json = await response.json();
  if (!response.ok || !json.success) {
    const error = new Error(json.message || 'Something went wrong');
    error.data = json;

    throw error;
  }

  return json;
};

/**
 * Send a POST request and return the response body as text.
 *
 * @param {string} url - The endpoint URL
 * @param {Object|FormData} payload - JSON object or form fields
 * @returns {Promise<string>}
 */
const postText = async (url, payload = {}) => {
  const isFormData = payload instanceof FormData;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      'X-CSRF-Token': getCsrfToken(),
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: isFormData ? payload : JSON.stringify(payload)
  });
  const text = await response.text();

  if (!response.ok) {
    const error = new Error('Something went wrong');
    error.responseText = text;

    throw error;
  }

  return text;
};

const mergeFormData = (...sources) => {
  const merged = new FormData();

  sources.forEach((source) => {
    source.forEach((value, key) => {
      if (key !== '_csrfToken' && !key.startsWith('_Token[')) {
        merged.append(key, value);
      }
    });
  });

  return merged;
};

const isFormValidSilently = (form, ignoredElements = []) => Array.from(form.elements).every(
  (element) => ignoredElements.includes(element) || !element.willValidate || element.validity.valid
);

const debounced = (delay, fn) => {
  let timerId;
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  }
};

const smoothScrollTo = (element, offset = 108, container = window) => {
  const elementPosition = element.offsetTop;
  const offsetPosition = elementPosition - offset;

  container.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
};

/**
 * Scroll inside the current document only. scrollIntoView() can scroll the host page to move the iframe — avoid it in the embed.
 *
 * @param {Element|null} element
 * @param {'start'|'center'} verticalAlign
 * @return {void}
 */
const scrollElementInIframe = (element, verticalAlign) => {
  if (!element) {
    return;
  }

  const offsetTopPx = 80;
  const elRect = element.getBoundingClientRect();
  const elTop = elRect.top;
  const elHeight = elRect.height;

  const tryScroll = (container) => {
    if (!container) {
      return false;
    }

    const style = window.getComputedStyle(container);

    if (!/^(auto|scroll|overlay)$/.test(style.overflowY)) {
      return false;
    }

    if (container.scrollHeight <= container.clientHeight + 1) {
      return false;
    }

    const cRect = container.getBoundingClientRect();
    let delta = elTop - cRect.top;

    if (verticalAlign === 'center') {
      delta -= (container.clientHeight - elHeight) / 2;
    }
    else {
      delta -= offsetTopPx;
    }

    container.scrollTo({
      top: Math.max(0, container.scrollTop + delta),
      behavior: 'smooth'
    });

    return true;
  };

  if (tryScroll(element.closest('.booking-layout'))) {
    return;
  }

  if (tryScroll(element.closest('.modal-container'))) {
    return;
  }

  const root = document.scrollingElement || document.documentElement;

  if (root.scrollHeight <= root.clientHeight + 1) {
    return;
  }

  let nextY = window.pageYOffset + elTop;

  if (verticalAlign === 'center') {
    nextY -= (window.innerHeight - elHeight) / 2;
  }
  else {
    nextY -= offsetTopPx;
  }

  window.scrollTo({
    top: Math.max(0, nextY),
    behavior: 'smooth'
  });
};

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
};

const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

const selectText = (selector) => {
  const node = document.querySelector(selector);

  if (document.body.createTextRange) {
    const range = document.body.createTextRange();
    range.moveToElementText(node);
    range.select();
  } else if (window.getSelection) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
  } else {
    console.warn("Could not select text in node: Unsupported browser.");
  }
};

/**
 * Copy text to the clipboard, with a fallback for browsers without Clipboard API access.
 *
 * @param {string} text - Text to copy
 * @return {Promise<boolean>}
 */
const copyTextToClipboard = async (text) => {
  const value = String(text == null ? '' : text);

  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(value);

      return true;
    } catch (error) {
      // Fall through to the selection-based copy used by older browsers.
    }
  }

  const copyInput = document.createElement('textarea');
  copyInput.value = value;
  copyInput.setAttribute('readonly', '');
  copyInput.style.position = 'fixed';
  copyInput.style.opacity = '0';
  document.body.appendChild(copyInput);
  copyInput.select();
  copyInput.setSelectionRange(0, copyInput.value.length);

  try {
    return document.execCommand('copy');
  } catch (error) {
    return false;
  } finally {
    copyInput.remove();
  }
};

/**
 * Bind reusable copy buttons contained in a DOM root.
 *
 * @param {Document|Element} root - DOM root containing copy controls
 * @param {Object} options - Optional selector and feedback overrides
 * @return {void}
 */
const bindCopyButtons = (root = document, options = {}) => {
  const settings = {
    containerSelector: '[data-copy-to-clipboard]',
    sourceSelector: '[data-copy-to-clipboard-source]',
    buttonSelector: '[data-copy-to-clipboard-button]',
    labelSelector: '[data-copy-to-clipboard-label]',
    idleIconSelector: '[data-copy-to-clipboard-icon]',
    successIconSelector: '[data-copy-to-clipboard-success-icon]',
    feedbackDuration: 1500,
    boundClass: '',
    ...options
  };

  root.querySelectorAll(settings.containerSelector).forEach((container) => {
    if (container.dataset.copyToClipboardBound === 'true') return;

    const source = container.querySelector(settings.sourceSelector);
    const button = container.querySelector(settings.buttonSelector);
    if (!source || !button) return;

    const label = container.querySelector(settings.labelSelector);
    const idleIcon = container.querySelector(settings.idleIconSelector);
    const successIcon = container.querySelector(settings.successIconSelector);
    const defaultLabel = label ? label.textContent : '';
    let resetTimeout;

    button.addEventListener('click', async () => {
      const sourceText = 'value' in source ? source.value : source.textContent;
      const copied = await copyTextToClipboard(sourceText);
      if (!copied) return;

      window.clearTimeout(resetTimeout);
      if (label && button.dataset.copiedLabel) {
        label.textContent = button.dataset.copiedLabel;
      }
      if (idleIcon && successIcon) {
        idleIcon.classList.add('hidden');
        successIcon.classList.remove('hidden');
      }

      resetTimeout = window.setTimeout(() => {
        if (label) label.textContent = defaultLabel;
        if (idleIcon && successIcon) {
          idleIcon.classList.remove('hidden');
          successIcon.classList.add('hidden');
        }
      }, settings.feedbackDuration);
    });

    container.dataset.copyToClipboardBound = 'true';
    if (settings.boundClass) container.classList.add(settings.boundClass);
  });
};

/**
 * Bind elements that toggle a specifically named content block.
 *
 * @param {Document|Element} root - DOM root containing triggers and content blocks
 * @param {Object} options - Optional selector and class overrides
 * @return {void}
 */
const bindToggleBlocks = (root = document, options = {}) => {
  const settings = {
    triggerSelector: '[data-toggle-block]',
    contentSelector: '[data-toggle-block-content]',
    hiddenClass: 'hidden',
    ...options
  };
  const contents = Array.from(root.querySelectorAll(settings.contentSelector));

  root.querySelectorAll(settings.triggerSelector).forEach((trigger) => {
    if (trigger.dataset.toggleBlockBound === 'true') return;

    const targetName = trigger.dataset.toggleBlock;
    const content = contents.find((item) => item.dataset.toggleBlockContent === targetName);
    if (!targetName || !content) return;

    trigger.addEventListener('click', () => {
      content.classList.toggle(trigger.dataset.toggleBlockClass || settings.hiddenClass);
    });

    trigger.dataset.toggleBlockBound = 'true';
  });
};

const appendGet = (key, value, url) => {
  if (!url) url = window.location.href;
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

  if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
          url = url.replace(re, '$1' + key + "=" + value + '$2$3');
      }
      else {
          hash = url.split('#');
          url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
          if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
              url += '#' + hash[1];
          }
      }
  }
  else {
      if (typeof value !== 'undefined' && value !== null) {
          var separator = url.indexOf('?') !== -1 ? '&' : '?';
          hash = url.split('#');
          url = hash[0] + separator + key + '=' + value;
          if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
              url += '#' + hash[1];
          }
      }
  }

  window.history.pushState("", "", url);
}

const isValidURL = (str) => {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

const getMapRadius = (pointA, pointB) => {
  const toRadians = (value) => {
    return value * Math.PI / 180;
  }

  let R = 6371e3;
  let lat1 = pointA.lat;
  let lat2 = pointB.lat;
  let lon1 = -pointA.lng;
  let lon2 = -pointB.lng;

  let φ1 = toRadians(lat1);
  let φ2 = toRadians(lat2);
  let Δφ = toRadians((lat2 - lat1));
  let Δλ = toRadians((lon2 - lon1));

  let a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = R * c;

  return parseInt(distance / 2); //Divide by 2 for radius from map center
}

const groupBy = (array, f) => {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  })
}

const closeAllDropdowns = () => {
  const allDropdowns = document.querySelectorAll('.dropdown.active');
  if(allDropdowns){
    allDropdowns.forEach(dropdown => {
      dropdown.classList.remove('active');
    });
  }
}

const isElementInViewport = (el) => {
  var rect = el.getBoundingClientRect();

  return rect.top < window.innerHeight && rect.bottom >= 0;
}

const onVisible = (el, callback) => {
  var old_visible;
  return function () {
      var visible = isElementInViewport(el);
      if (visible != old_visible && visible) {
          old_visible = visible;
          if (typeof callback == 'function') {
              callback();
          }
      }
  }
}

const dynamicSort = (property, order = 'ASC', locationType = '') => {
  var sortOrder = 1;
  if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }
  return function (a,b) {
    if(property === 'featured_on'){
      if (typeof a['featured_on'] !== 'undefined' && a['featured_on'].indexOf(locationType) !== -1) {
        return -1 * sortOrder; // Promoted value should be placed at the beginning
      }
      if (typeof b['featured_on'] !== 'undefined' && b['featured_on'].indexOf(locationType) !== -1) {
        return 1 * sortOrder; // Promoted value should be placed at the beginning
      }
    }

    if(order === 'ASC')
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    else{
      var result = (a[property] < b[property]) ? 1 : (a[property] > b[property]) ? -1 : 0;
    }

    return result * sortOrder;
  }
}

const splitFullname = (name = '') => {
  const [firstName, ...lastName] = name.split(' ').filter(Boolean);
  return {
    firstName: firstName,
    lastName: lastName.join(' ')
  }
}

const checkMailPhoneUrlInText = (text) => {
  const emailPattern = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
  const phonePattern = /\b[\+]?[(]?[0-9]{2,6}[)]?[-\s\.]?[-\s\/\.0-9]{6,15}\b/m;
  const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

  let emailPresence = text.match(emailPattern);
  let phonePresence = text.match(phonePattern);
  let urlPresence = text.match(urlPattern);

  return emailPresence || phonePresence || urlPresence;
}

//check if there are 6 or more capitalized letters in input
const checkConsecutiveCapitalizedLetters = (text) => {
  const pattern = /\w*[A-Z]\w*[A-Z]\w*[A-Z]\w*[A-Z]\w*[A-Z]\w*[A-Z]\w*/g;
  let capitalizedLettersPresence = text.match(pattern);

  return capitalizedLettersPresence;
}

const deleteCookie = (cookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

const formatCurrency = (amount, locale, currencyIso, minimumFractionDigits = 0) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyIso,
    minimumFractionDigits
  }).format(amount);
}

/**
 * Convert a positive decimal amount into cents without floating-point rounding.
 *
 * @param {string|number} value - Decimal amount
 * @return {number|null}
 */
const decimalAmountToCents = (value) => {
  const amount = String(value);
  if (!/^\d+(?:\.\d{1,2})?$/.test(amount)) {
    return null;
  }

  const parts = amount.split('.');
  const decimals = ((parts[1] || '') + '00').slice(0, 2);

  return (parseInt(parts[0], 10) * 100) + parseInt(decimals || '0', 10);
}

/**
 * Observes changes to the class attribute of a target element and invokes a callback when it changes.
 *
 * @param {Element} targetElement - The target element to observe
 * @param {Function} callback - The callback function to invoke when the class attribute changes
 * @return {void}
 */
const observeClassChangeOn = (targetElement, callback) => {
  let observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        callback();
      }
    });
  });

  observer.observe(targetElement, {
    attributes: true,
    attributeFilter: ['class']
  });
}

// Get distance in meters between two pairs of lat lng
const getDistance = (lat1, lng1, lat2, lng2) => {
  const deg2rad = (deg) => {
    return deg * Math.PI / 180;
  }

  const earthRadius = 6371; // Earth's radius in kilometers

  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lng2 - lng1);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.asin(Math.sqrt(a));
  const d = earthRadius * c;

  return d * 1000; // return distance in meters
}

/**
 * Get human-readable distance string.
 * Format: "{0} miles distance" for en_US, "{0} km distance" otherwise.
 * @param {number} distanceInMeters - Distance in meters
 * @param {string} milesText - Translation template for miles (e.g. "{0} miles distance")
 * @param {string} kmText - Translation template for km (e.g. "{0} km distance")
 * @param {string} nearbyText - Translation for "Nearby" when distance is 0
 * @param {boolean} isEnUs - Whether locale is en_US
 * @returns {string}
 */
const getHumanDistance = (distanceInMeters, milesText, kmText, nearbyText, isEnUs) => {
  if(distanceInMeters === 0 || distanceInMeters == null){
    return nearbyText;
  }

  if(isEnUs){
    const miles = 0.00062137 * distanceInMeters;
    return milesText.replace('{0}', Math.round(miles * 10) / 10);
  }

  const km = distanceInMeters / 1000;
  return kmText.replace('{0}', Math.round(km * 10) / 10);
};

// Function to calculate Levenshtein distance for sorting
const getLevenshteinDistance = (a, b) => {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  const matrix = [];

  // Initialize matrix
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Fill matrix
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

const toggleButtonLoading = (button, loading = true) => {
  if(button){
    button.disabled = loading;
    button.classList.toggle('loading', loading);
  }
}

const setHiddenInputValue = (form, name, value) => {
  let input = form.querySelector(`input[name="${name}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }

  input.value = value || '';
};

/**
 * Convert server-rendered HTML into one DOM element.
 *
 * @param {string} html
 * @return {HTMLElement|null}
 */
const createElementFromHtml = (html) => {
  const template = document.createElement('template');
  template.innerHTML = html.trim();

  return template.content.firstElementChild;
}

/**
 * Parse a JSON string safely.
 *
 * @param {string} value
 * @param {*} fallback
 * @return {*}
 */
const parseJson = (value, fallback = null) => {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

/**
 * Parse a JSON array string safely.
 *
 * @param {string} value
 * @return {Array}
 */
const parseJsonArray = (value) => {
  const parsedValue = parseJson(value, []);

  return Array.isArray(parsedValue) ? parsedValue : [];
}

/**
 * Read the CSRF token from the existing meta tag.
 *
 * @return {string}
 */
const getCsrfToken = () => {
  const tokenInput = document.getElementsByName('csrfToken');
  if (!tokenInput || tokenInput.length === 0) return '';

  return tokenInput[0].content || '';
}

/**
 * Build star rating HTML
 *
 * @param {number} averageReview - The average review rating (0-5)
 * @param {string} size - The size class for the stars (default: 'text-xs')
 * @param {string} colorFilled - The color class for filled stars (default: 'text-me-light-brown')
 * @param {string} colorEmpty - The color class for empty stars (default: 'text-gray-500')
 * @return {string} HTML string with star rating
 */
const buildStarsHtml = (averageReview, size = 'text-xs', colorFilled = 'text-me-light-brown', colorEmpty = 'text-gray-500') => {
  const starsPercentage = averageReview * 20; // Convert rating to percentage (5 stars = 100%)

  return `
    <div class="star-rating inline-block">
      <div class="back-stars">
        <i class="icon icon-star-alt ${size} ${colorEmpty}"></i>
        <i class="icon icon-star-alt ${size} ${colorEmpty}"></i>
        <i class="icon icon-star-alt ${size} ${colorEmpty}"></i>
        <i class="icon icon-star-alt ${size} ${colorEmpty}"></i>
        <i class="icon icon-star-alt ${size} ${colorEmpty}"></i>
        <div class="front-stars" style="width: ${starsPercentage}%">
          <i class="icon icon-star-alt ${size} ${colorFilled}"></i>
          <i class="icon icon-star-alt ${size} ${colorFilled}"></i>
          <i class="icon icon-star-alt ${size} ${colorFilled}"></i>
          <i class="icon icon-star-alt ${size} ${colorFilled}"></i>
          <i class="icon icon-star-alt ${size} ${colorFilled}"></i>
        </div>
      </div>
    </div>`;
}

/**
 * Lowercase text and strip diacritics so client-side searches ignore case and accents.
 *
 * @param {string} text
 * @returns {string}
 */
const normalizeSearchText = (text) => (text || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .trim();

/**
 * Escape a value before inserting it into HTML markup or an attribute.
 *
 * @param {*} value - Value to escape
 * @returns {string}
 */
const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

export { isMobile,
          getUserLanguage,
          isHidden,
          isHiddenAlt,
          formattedDate,
          ajax,
          debounced,
          dateToString,
          smoothScrollTo,
          scrollElementInIframe,
          capitalize,
          isValidDate,
          appendGet,
          selectText,
          copyTextToClipboard,
          bindCopyButtons,
          bindToggleBlocks,
          isValidURL,
          getMapRadius,
          groupBy,
          closeAllDropdowns,
          isElementInViewport,
          onVisible,
          dynamicSort,
          splitFullname,
          checkMailPhoneUrlInText,
          checkConsecutiveCapitalizedLetters,
          deleteCookie,
          ymdFormattedDate,
          formatCurrency,
          decimalAmountToCents,
          getCsrfToken,
          getHtml,
          getJson,
          postJson,
          postText,
          mergeFormData,
          isFormValidSilently,
          observeClassChangeOn,
          getDistance,
          getHumanDistance,
          getLevenshteinDistance,
          toggleButtonLoading,
          createElementFromHtml,
          parseJson,
          parseJsonArray,
          setHiddenInputValue,
          buildStarsHtml,
          normalizeSearchText,
          escapeHtml
      }
